<template>
    <div class="jzart-mask" v-show="isShow">
        <div class="jzart jzart-anim jzart-iframe" style="margin-top: -200px; margin-left: -250px; width: 500px; height: 400px;">
            <div class="jzart-top" style="cursor: move;">
                <a class=" jzart-ico jzart-top-close jzart-top-close1" @click="hide" title="关闭"></a>
                <div v-show="islogin" class="jzart-top-title">我要登录</div>
                <div v-show="isregist" class="jzart-top-title">我要注册</div>
            </div>
            <div class="m-pop">
                <ul class="m-login">
                    <li>
                        <span>手机号：</span>
                        <input name="useraccount" v-model="useraccount" type="text" placeholder="请输入手机号" data-check="required:true" maxlength="20" />
                    </li>
                    <li>
                        <span>密&nbsp;&nbsp;&nbsp;&nbsp;码：</span>
                        <input name="password" v-model="password" type="password" placeholder="请输入8位以上密码" data-check="required" maxlength="20" />
                    </li>
                    <li>
                        <span>验证码：</span>
                        <input name="validatecode" v-model="validatecode" type="text" placeholder="请输入验证码" data-check="required:true" maxlength="20" />
<!--                        <td>-->
                            <img :src=validatecodeimg style="display: none" id="validatecodeimg" @click="reload_validatecode">
                            <a href="javascript:void(0)" @click="show_validatecode" id="validshow">点击获取验证码</a>
<!--                        </td>-->
<!--                        <a class="u-button primary cord">发送验证码</a>-->
                    </li>
                    <li v-show="isregist">
                        <p class="ruletip"><i class="u-checkbox"></i>阅读并接受<a>《用户协议》</a>和<a>《隐私条款》</a></p>
                    </li>
                </ul>
                <div class="m-btns">
                    <a class="u-button primary login" href="javascript:void(0);" @click="loginin" v-show="islogin">登录</a>
                    <a class="u-button primary login" @click="loginin" v-show="isregist">注册</a>
                </div>
                <p class="m-toinfo " v-show="islogin">还没有登录账号？<a href="javascript:void(0);"  @click="changelogin(1)">立即注册</a></p>
                <p class="m-toinfo " v-show="isregist">已有账号？<a href="javascript:void(0);"  @click="changelogin(2)">立即登录</a></p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'loginer',
        props: {},
        data() {
            return {
                useraccount: "",
                password: "",
                validatecode: "",
                validatecodeimg: "",
                errormsg: "",
                isShow: false,
                islogin: true,
                isregist: false,
            };
        },
        mounted() {
        },
        methods: {
            changelogin(index){
                if(index===1){
                    this.islogin=false;
                    this.isregist=true;
                }else{
                    this.islogin=true;
                    this.isregist=false;
                }
            },
            show() {
                this.isShow = true;
            },
            hide() {
                this.isShow = false;
            },
            show_validatecode() {
                this.validatecodeimg = "/validatecode/login?t=equation&_=" + new Date().getTime();
                $("#validatecodeimg").show();
                $("#validshow").hide();
            },
            reload_validatecode(){
                this.validatecodeimg = "/validatecode/login?t=equation&_=" + new Date().getTime();
            },
            async loginin() {
                if (!this.useraccount) {
                    this.errormsg = "请输入账号";
                    return;
                }
                if (!this.password) {
                    this.errormsg = "请输入密码";
                    return;
                }
                const param ={
                    useraccount: this.useraccount,
                    password:this.password,
                    validatecode: this.validatecode,
                };

                if(this.islogin){//登录
                    let data = await this.ajax.postJson('/webtoken/login.do', param);
                    console.log(data);
                    if (data.msg === 'success') {
                        this.isShow = false;
                        location.reload();
                    } else {
                        this.password = "";
                        this.validatecode = "";
                        this.useraccount = "";
                        this.show_validatecode();
                    }
                }else {//注册
                    let ischecked = $('.u-checkbox').is(".icon-checkboxsel");
                    if (ischecked) {
                        let data = await this.ajax.postJson('/registerbytdpweb', param);
                        if (data === undefined) {
                            this.islogin = true;
                            this.isregist = false;
                        }
                    } else {
                        alert('请查阅用户协议！');
                    }
                }
            }
        }
    };
</script>
